import { Divider, Grid, useTheme } from '@mui/material';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import FinanceTrialTable from './FinanceTrialTable';

const FinAdminDashboard = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Grid container >
      <Grid item sm={12} >
        <FinanceTrialTable />
      </Grid>
    </Grid>
  );
}

export default FinAdminDashboard
